"use strict";
'use client';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const MuiLicenseInfoContext = /*#__PURE__*/React.createContext({
  key: undefined
});
if (process.env.NODE_ENV !== "production") MuiLicenseInfoContext.displayName = "MuiLicenseInfoContext";
var _default = exports.default = MuiLicenseInfoContext;